<template>
    <section class="row mt-5">
        <div class="col-12">
            <div class="row">
                <div class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">
                        <div :class="{'active': itemIndex === 0}" :key="'item' + itemIndex"
                             class="carousel-item" v-for="(itemValue, itemIndex) in topSliderItemsList">
                            <img :src="assetsBaseUrl + itemValue.filePath" class="d-block w-100">
                            <div class="carousel-caption d-none d-md-block">
                                <h1>{{ itemValue.title }}</h1>
                                <h3>{{ itemValue.description }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "TopSliderComponent",
        data() {
            return {
                assetsBaseUrl: process.env.VUE_APP_API_DOMAIN + process.env.VUE_APP_ASSETS_PATH + '/',
                topSliderItemsList: null
            }
        },
        async mounted() {
            // get top-slider items list
            this.topSliderItemsList = await this.$store.state.sliders.topSlider.itemsList;
            // init carousel
            $('.carousel').carousel();
        }
    }
</script>

<style scoped>

</style>
